module.exports = __webpack_public_path__ + "static/img/device.2f136749.jpg";